<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Audit' }">Audit</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Audit ccwf'}">
          {{ $root.getHeader() }} Audit report for Credit Card fee waived
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-table :data="ccItems" v-loading="loading">
      <el-table-column label="Transaction ID" prop="id" :width="120"></el-table-column>
      <el-table-column label="Created At" :width="100">
        <template slot-scope="scope">
          {{ new Date(scope.row.createdAt).toLocaleString() }}
        </template>
      </el-table-column>
      <el-table-column
        label="Amount"
        prop="amount"
        :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
      >
      </el-table-column>
      <el-table-column label="Created By" prop="createdBy" :width="200"></el-table-column>
      <el-table-column label="For" prop="customer.company"></el-table-column>
      <el-table-column label="Description" prop="details" :width="350"></el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import axios from 'axios';
import { FACILITY_TRANSACTIONS_API_BASE } from '../env';

export default {
  name: 'AuditCCFW',
  props: {
    facility: { type: String, required: true }
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getVoidItems();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getVoidItems();
    this.loading = false;
  },
  data() {
    return {
      ccItems: [],
      loading: false,
    };
  },
  methods: {
    async getVoidItems() {
      const response = await axios.get(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${this.facility}/waived/transactions`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.ccItems = response.data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AuditCCFW.vue